export default "__VITE_PUBLIC_ASSET__ae0b6095__"